import React from "react";
import "./About.scss";

export default class About extends React.Component {
  render() {
    return (
      <div className="about py-5" id="About" data-scroll-section>
        <div className="d-flex flex-column flex-lg-row container my-5 gap-5">
          <div className="about-section container col-12 col-lg-8 mb-5 d-flex flex-column gap-5">
            <div>
              <h1 className="mb-5">
                You bring the vision—or we do. We shape it, sharpen it, and make
                it unforgettable
              </h1>
            </div>
            <div>
              <h1 className="mb-4 fw-bold">Careers</h1>
              <h4 className="pe-5 mb-2">
                We’re always looking for exceptional talent. If you’re a Houdini
                artist, comp artist (Nuke), 3D artist, animator, generalist,
                roto/paint/cleanup artist, matchmove artist, lighting artist, or
                FX artist ready to help shape the future of visual storytelling,
                we’d love to hear from you.
              </h4>
              <a href="mailto:careers@side-eye.com" className="email-link">
                <h5>→ careers@side-eye.com</h5>
              </a>
            </div>
          </div>
          <div className="container about-section col-12 col-lg-4">
            <div>
              <div>
                <p>If you have a new project to discuss{""}</p>
                <a href="mailto:contact@sideeye.com" className="email-link">
                  contact@side-eye.com
                </a>
              </div>
              <div className="my-4">
                <p>If you want to become a team member{""}</p>
                <a href="mailto:careers@sideeye.com" className="email-link">
                  careers@side-eye.com
                </a>
              </div>
            </div>
            <div className="my-5 d-flex gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                width="20"
                height="20"
                viewBox="0 0 256 256"
              >
                <g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                  <path
                    d="M 45 0 C 27.677 0 13.584 14.093 13.584 31.416 c 0 4.818 1.063 9.442 3.175 13.773 c 2.905 5.831 11.409 20.208 20.412 35.428 l 4.385 7.417 C 42.275 89.252 43.585 90 45 90 s 2.725 -0.748 3.444 -1.966 l 4.382 -7.413 c 8.942 -15.116 17.392 -29.4 20.353 -35.309 c 0.027 -0.051 0.055 -0.103 0.08 -0.155 c 2.095 -4.303 3.157 -8.926 3.157 -13.741 C 76.416 14.093 62.323 0 45 0 z M 45 42.81 c -6.892 0 -12.5 -5.607 -12.5 -12.5 c 0 -6.893 5.608 -12.5 12.5 -12.5 c 6.892 0 12.5 5.608 12.5 12.5 C 57.5 37.202 51.892 42.81 45 42.81 z"
                    transform=" matrix(1 0 0 1 0 0) "
                    stroke-linecap="round"
                  />
                </g>
              </svg>
              <p>Los Angeles - New York</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
